import { Injectable } from '@angular/core';
import {
  CRMAlarm,
  CRMResolution,
  CRMResolutionAction,
  CRMResolutionEntity,
  CRMTrigger,
  CRMTriggerType
} from '../../shared/models/crm/CRMAlarm.model';
import { CRMItem } from '../../shared/models/crm/CRMItem.model';
import { CRMStatus } from '../../shared/models/crm/CRMStatus';
import { StructCapCRMStatus } from 'src/app/shared/enums/struct-cap-crm-status';
import { StructCapCRMItem } from 'src/app/shared/models/crm/struct-cap/StructCapCRMItem.model';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class CrmAlarmUtilsService {

  constructor() { }

  public createSilenceAlarm(crmId: number, silenceUntil: DateTime, status: CRMStatus | StructCapCRMStatus): CRMAlarm {
    if (status === StructCapCRMStatus.PASSED_FLAGGED_FOR_FOLLOW_UP) {
      return this.createStructCapSilenceAlarm(crmId, silenceUntil, status);
    } else {
      return this.createStandardSilenceAlarm(crmId, silenceUntil, status);
    }
  }

  private createStandardSilenceAlarm(crmId: number, silenceUntil: DateTime, status: CRMStatus | StructCapCRMStatus): CRMAlarm {
    const alarm = new CRMAlarm();
    alarm.provisional = status === CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION;
    alarm.trigger = new CRMTrigger();
    alarm.trigger.type = CRMTriggerType.TEMPORAL;
    alarm.trigger.value = silenceUntil.toISO();
    const resolution = new CRMResolution();
    resolution.action = CRMResolutionAction.SET;
    resolution.entity = CRMResolutionEntity.CRM_ITEM;
    resolution.entityId = `${crmId}`;
    resolution.property = 'status';
    resolution.value = CRMStatus.UNSILENCED;
    alarm.resolutionList = [resolution];
    return alarm;
  }

  private createStructCapSilenceAlarm(crmId: number, silenceUntil: DateTime, status: StructCapCRMStatus): CRMAlarm {
    const alarm = new CRMAlarm();
    alarm.provisional = false;
    alarm.trigger = new CRMTrigger();
    alarm.trigger.type = CRMTriggerType.TEMPORAL;
    alarm.trigger.value = silenceUntil.toISO();
    const resolution = new CRMResolution();
    resolution.action = CRMResolutionAction.SET;
    resolution.entity = CRMResolutionEntity.CRM_ITEM;
    resolution.entityId = `${crmId}`;
    resolution.property = 'status';
    resolution.value = StructCapCRMStatus.FOLLOW_UP_REACTIVATED;
    alarm.resolutionList = [resolution];
    return alarm;
  }

  public findSilenceAlarm(crmItem: CRMItem | StructCapCRMItem): CRMAlarm {
    if (crmItem && crmItem.alarms && crmItem.alarms.length > 0) {
      return crmItem.alarms.find(a =>
        a.trigger &&
        a.trigger.type === CRMTriggerType.TEMPORAL &&
        a.resolutionList &&
        a.resolutionList.length >= 1 &&
        a.resolutionList[0].action === CRMResolutionAction.SET &&
        a.resolutionList[0].entity === CRMResolutionEntity.CRM_ITEM &&
        a.resolutionList[0].property === 'status' &&
        (a.resolutionList[0].value === CRMStatus.UNSILENCED ||
          a.resolutionList[0].value === StructCapCRMStatus.FOLLOW_UP_REACTIVATED) &&
        a.resolutionList[0].entityId === `${crmItem.id}`);
    } else {
      return null;
    }
  }

  public findArchiveAlarm(crmItem: CRMItem): CRMAlarm {
    if (crmItem && crmItem.alarms && crmItem.alarms.length > 0) {
      return crmItem.alarms.find(a =>
        a.trigger &&
        a.trigger.type === CRMTriggerType.TEMPORAL &&
        a.resolutionList &&
        a.resolutionList.length >= 1 &&
        a.resolutionList[0].action === CRMResolutionAction.SET &&
        a.resolutionList[0].entity === CRMResolutionEntity.CRM_ITEM &&
        a.resolutionList[0].property === 'archive' &&
        a.resolutionList[0].value === 'true' &&
        a.resolutionList[0].entityId === `${crmItem.id}`);
    } else {
      return null;
    }
  }
}
